import { lazy } from "react";
import { MdBackup, MdBarChart, MdBusiness, MdChat, MdDescription, MdForum, MdHistory, MdOutgoingMail, MdViewModule, MdVpnKey, MdWorkHistory } from "react-icons/md";

// Módulos de administración que viven dentro de Configuraciones, en el orden del menú.
// `key` es lo que va en la URL (?seccion=...). Las vistas se cargan solo al abrirlas.
export const SECCIONES_CONFIGURACION = [
  {
    key: "empresa",
    name: "Empresa",
    moduleKey: "configuracion_empresa",
    icon: MdBusiness,
    component: lazy(() => import("views/admin/ConfiguracionEmpresa")),
  },
  {
    key: "plantillas-documentos",
    name: "Plantillas de documentos",
    moduleKey: "plantillas_documentos",
    icon: MdDescription,
    component: lazy(() => import("views/admin/PlantillasDocumentos")),
  },
  {
    key: "reportes-ia",
    name: "Reportes IA",
    moduleKey: "reportes_ia",
    icon: MdBarChart,
    component: lazy(() => import("views/admin/ReportesIA")),
  },
  {
    key: "modulos",
    name: "Modulos",
    moduleKey: "modulos",
    icon: MdViewModule,
    component: lazy(() => import("views/admin/Modulos")),
  },
  {
    key: "licencias",
    name: "Licencias",
    moduleKey: "licencias",
    icon: MdVpnKey,
    component: lazy(() => import("views/admin/Licencias")),
  },
  {
    key: "jobs",
    name: "Jobs",
    moduleKey: "jobs",
    icon: MdWorkHistory,
    component: lazy(() => import("views/admin/Jobs")),
  },
  {
    key: "correo-cotizaciones",
    name: "Correo de cotizaciones",
    moduleKey: "correo_cotizaciones",
    icon: MdOutgoingMail,
    component: lazy(() => import("views/admin/ConfiguracionCorreo")),
  },
  {
    key: "whatsapp",
    name: "WhatsApp",
    moduleKey: "configuracion_whatsapp",
    icon: MdChat,
    component: lazy(() => import("views/admin/ConfiguracionWhatsApp")),
  },
  {
    key: "auditoria",
    name: "Auditoría",
    moduleKey: "auditoria",
    icon: MdHistory,
    component: lazy(() => import("views/admin/Auditoria")),
  },
  {
    key: "respaldos",
    name: "Respaldos y alertas",
    moduleKey: "respaldos",
    icon: MdBackup,
    component: lazy(() => import("views/admin/Respaldos")),
  },
  {
    key: "chat",
    name: "Chat interno",
    moduleKey: "configuracion_chat",
    icon: MdForum,
    component: lazy(() => import("views/admin/ConfiguracionChat")),
  },
];
